import { render } from "./rechargeComplain.vue?vue&type=template&id=3e95cefe&scoped=true"
import script from "./rechargeComplain.vue?vue&type=script&lang=js"
export * from "./rechargeComplain.vue?vue&type=script&lang=js"

import "./rechargeComplain.vue?vue&type=style&index=0&id=3e95cefe&scoped=true&lang=css"
import "./rechargeComplain.vue?vue&type=style&index=1&id=3e95cefe&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e95cefe"]])

export default __exports__